/*
  rk Footer: Link-Spalten sind mobil ein Akkordeon (<details>), ab 750px immer offen.
  Ohne JS bleiben alle Spalten offen.
*/
(() => {
  if (window.RkFooterAccordion) return;
  window.RkFooterAccordion = true;

  const desktop = window.matchMedia('(min-width: 750px)');

  const sync = () => {
    document.querySelectorAll('[data-rk-accordion]').forEach((details) => {
      details.open = desktop.matches;
    });
  };

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('[data-rk-accordion] > summary');
    if (summary && desktop.matches) event.preventDefault();
  });

  desktop.addEventListener?.('change', sync);
  document.addEventListener('shopify:section:load', sync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
